import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "edit-connection",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = { class: "edit-header d-flex flex-row justify-content-between" }
const _hoisted_4 = {
  id: "connection-label",
  class: "label d-flex align-items-center"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start",
  style: {"width":"116px"}
}
const _hoisted_6 = { class: "img-box-white d-flex align-items-center justify-content-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-body overflow-auto font-size-14" }
const _hoisted_9 = {
  key: 0,
  id: "dynamic-spec-warning",
  class: "dynamic-spec-warning d-flex flex-row",
  role: "alert"
}
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_14 = {
  key: 0,
  class: "warning-div"
}
const _hoisted_15 = { class: "warning-text" }
const _hoisted_16 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_17 = { class: "d-flex w-100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_19 = { style: {"float":"left"} }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_25 = {
  key: 1,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_27 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_28 = {
  key: 0,
  class: "margin-right-10 d-flex align-items-center"
}
const _hoisted_29 = {
  key: 2,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_31 = { class: "margin-top-10 d-flex flex-column padding-top-10" }
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_34 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_36 = {
  key: 3,
  class: "margin-top-10"
}
const _hoisted_37 = { id: "formAuthType" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_39 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_41 = {
  key: 4,
  class: "margin-top-10"
}
const _hoisted_42 = { id: "tokenAuthType" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_44 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_46 = {
  key: 5,
  class: "margin-top-10"
}
const _hoisted_47 = { id: "apiKeyAuthType" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_49 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_51 = {
  key: 6,
  class: "margin-top-10"
}
const _hoisted_52 = { id: "oAuthType" }
const _hoisted_53 = { class: "d-flex flex-column" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_55 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1)
const _hoisted_57 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_58 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-items-center margin-top-10"
}
const _hoisted_59 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_60 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "loader-div-sm" }
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "card-footer footer" }
const _hoisted_65 = { class: "float-right" }
const _hoisted_66 = { class: "loader-div-40" }
const _hoisted_67 = ["src"]
const _hoisted_68 = { class: "d-flex justify-content-end align-items-center w-100 m-1" }
const _hoisted_69 = ["href"]
const _hoisted_70 = ["data"]
const _hoisted_71 = ["src"]

import {
  computed,
  defineAsyncComponent,
  onBeforeMount,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import { ElButton, ElInput, ElOption, ElSelect, ElSwitch } from "element-plus";
import { TYPE } from "vue-toastification";
import { JsonForms } from "@jsonforms/vue";
import { createAjv } from "@jsonforms/core";
import { cloneDeep } from "lodash-es";
import { currentRoute, router } from "@/core/router";
import {
  convertObject,
  convertToDefinitions,
  disconnectOAuth,
  getConnection,
  getConnectorAuthSchemas,
  getConnectorSpecById,
  getDynamicSpecStatus,
  getOAuthUrl,
  getOrganizationsConnectorList,
  saveConnection,
  verifyOauth,
} from "@/connection/services/connection.service";
import Modal from "@/connection/components/Modal.vue";
import { showAlert, showConfirm } from "@/core/popup";
import { hasPermission } from "@/core/auth";
import { isAuthValid } from "@/connection/utils/authValidation";
import i18n from "@/core/i18n/i18n";
import {
  defaultRenderers as renderers,
  styles,
} from "@/core/json-forms/json-forms";
import { changeListItemOfBreadcrumb } from "@/core/layout";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";

interface SettingsData {
  name: string;
  schema: any;
  data: any;
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditConnection',
  setup(__props) {

provide("styles", styles);

const AuthenticationForm = defineAsyncComponent(
  () => import("@/connection/components/AuthenticationForm.vue")
);

const charLimit = ref(255);

const isNameNearLimit = computed(
  () => connection.value.name?.length > charLimit.value
);

// Per-revision dynamic-connector spec-generation status (fetched from the backend), used to show a
// persistent warning banner. The credentials are always saved; a FAILED status means the spec for
// the latest revision couldn't be generated, so some operations may be unavailable until fixed.
const dynamicSpecStatus = ref<{
  status?: string;
  lastError?: string;
  revision?: number;
} | null>(null);

const dynamicSpecFailed = computed(
  () => dynamicSpecStatus.value?.status === "FAILED"
);

// Refresh the dynamic-spec status for the given connection; a failed attempt also raises a one-time
// warning toast so it isn't missed. Safe to call for any connection (no-op for non-dynamic ones).
async function refreshDynamicSpecStatus(connectionId: string, notify = false) {
  if (!connectionId) {
    dynamicSpecStatus.value = null;
    return;
  }
  const status = await getDynamicSpecStatus(connectionId);
  dynamicSpecStatus.value = status ?? null;
  if (notify && status?.status === "FAILED") {
    showAlert(
      TYPE.WARNING,
      t("Connection.DynamicSpecFailedMessage", {
        reason: status.lastError || t("Common.UnknownError"),
      })
    );
  }
}

const ajv = createAjv({ useDefaults: true });

const helpUrl = computed(() => {
  const getCurrentLanguage = currentRoute.value.path.split("/");
  if (getCurrentLanguage[1] === "en") {
    return "https://docs.oneteg.com/documentation-home/connector-help";
  }
  return "https://docs.oneteg.com/documentation-home/connector-help";
});

const { t } = i18n.global;
const pageName = computed(() =>
  currentRoute.value.name === "createConnection"
    ? t("Common.Create")
    : t("Common.Edit")
);
const connectorList = ref([]);
const selectedSpec = ref();
const id = ref();
const specLoading = ref(false);

const additionalSettingsErrorMap = ref(new Map());

const selectedConnectorSpecId = ref();

const connection = ref(defaultConnection());
const showModal = ref(false);
const pageLoading = ref(false);
const selectedLanguage = ref("en");
const responseLoading = ref(false);

const dataList = ref(new Array<SettingsData>());

const clicked = ref(false);

const verified = ref(false);
const isPasswordFieldClicked = ref(false);
const isSecretFieldClicked = ref(false);
const holdPassword = ref("");
const holdClientSecret = ref("");
const representPassword = ref("");
const representClientSecret = ref("");
const additionalSettings = computed(() => {
  const obj = {};
  dataList.value.forEach((data) => {
    obj[data.name] = {
      name: data.name,
      description: data.description,
      connectionSettingDefinitions: convertToDefinitions(data.data),
    };
  });
  return obj;
});

const authObject = ref({
  authenticationType: undefined,
  oauth: {
    clientId: "",
    clientSecret: "",
    callbackUrl: "",
    endPoint: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    tokenExpiry: undefined,
  },
  basicAuth: {
    endPoint: undefined,
    username: undefined,
    password: undefined,
  },
  formAuth: {
    form: undefined,
    authentication: undefined,
    endPoint: undefined,
  },
  tokenAuth: {
    authToken: undefined,
    endPoint: undefined,
  },
  apiKeyAuth: {
    apiKey: undefined,
    nameInHeader: undefined,
  },
});

const authItems = ref();

const authMap = ref(new Map());

// AJV errors for the auth forms, reported by AuthenticationForm and used by authIsValid.
const authErrors = ref([]);

function convertToAuth(map) {
  const obj = {};
  map.forEach((value, key) => {
    if (key === "custom") {
      connection.value.authentication.authenticationType = "CUSTOM";
    } else if (key === "oauth") {
      connection.value.authentication.authenticationType = "Oauth";
    } else if (key === "bearer") {
      connection.value.authentication.authenticationType = "BEARER";
    } else if (key === "postads") {
      connection.value.authentication.authenticationType = "POSTADS";
    } else if (key === "apiKey") {
      connection.value.authentication.authenticationType = "Api_key";
    } else if (key === "basic") {
      connection.value.authentication.authenticationType = "Basic";
    } else if (key.toLowerCase() === "jwt") {
      connection.value.authentication.authenticationType = "JWT";
    } else if (key.toLowerCase() === "awssigv4") {
      connection.value.authentication.authenticationType = "AWS_SIGV4";
    } else if (key.toLowerCase() === "woodwingstudio") {
      connection.value.authentication.authenticationType = "WOODWING_STUDIO";
    }
    // The backend now reports the type for each scheme. Prefer it, so a newly added
    // scheme works without a UI change; the branches above remain as a fallback for
    // backends that predate that field.
    if (value.authenticationType) {
      connection.value.authentication.authenticationType =
        value.authenticationType;
    }
    if (!value.flows) {
      obj[key] = convertToDefinitions(value.data);
    } else {
      obj[key] = convertToAuth(value.flowData);
    }
  });
  return obj;
}

function defaultConnection() {
  return {
    name: undefined,
    authentication: {
      authenticationType: undefined,
      oauth: {
        clientId: "",
        clientSecret: "",
        callbackUrl: "",
        endPoint: undefined,
        accessToken: undefined,
        refreshToken: undefined,
        tokenExpiry: undefined,
      },
      basicAuth: {
        endPoint: undefined,
        username: undefined,
        password: undefined,
      },
      formAuth: {
        form: undefined,
        authentication: undefined,
        endPoint: undefined,
      },
      tokenAuth: {
        authToken: undefined,
        endPoint: undefined,
      },
      apiKeyAuth: {
        apiKey: undefined,
        nameInHeader: undefined,
      },
    },
    connector: {
      active: true,
      camelComponentName: undefined,
      connectorSpecId: undefined,
      createdAt: undefined,
      createdBy: {
        id: undefined,
      },
      connectorType: undefined,
      description: undefined,
      hasConsumer: false,
      id: undefined,
      modifiedBy: {
        id: undefined,
      },
      name: undefined,
      organisation: {
        id: undefined,
        createdBy: {
          id: undefined,
        },
        modifiedBy: {
          id: undefined,
        },
      },
      pricingType: undefined,
      updatedAt: undefined,
    },
    additionalSettings: undefined,
    authParams: undefined,
    sslValidation: true,
    followRedirects: true,
  };
}

const isValid = computed(
  () => connection.value.name && connection.value.connector && !hasError()
);

const oauthResult = ref({
  state: "",
  authorizeUrl: "",
});

const authIsValid = computed(() =>
  isAuthValid({
    authItems: authItems.value,
    authMap: authMap.value,
    authErrors: authErrors.value,
    authenticationType: connection.value.authentication.authenticationType,
    authObject: authObject.value,
  })
);

const canSave = computed(() => !!isValid.value && authIsValid.value);

// True when the selected connector's only supported auth type is NONE. In that case the auth
// dropdown offers no real choice, so it's hidden and the type is defaulted to NONE (see the
// selectedConnectorSpecId watch) so a valid auth type is still persisted. Only relevant to the
// supportedAuthTypes fallback UI; connectors with dedicated auth schemas (authItems) are unaffected.
const onlyNoneAuth = computed(() => {
  const types = selectedSpec.value?.supportedAuthTypes;
  return (
    Array.isArray(types) &&
    types.length === 1 &&
    types[0]?.toUpperCase() === "NONE"
  );
});

// Hide the bold group header when it just repeats the single field's label
// (e.g. a "Metadata Path(s)" group whose only field is also "Metadata Path(s)"), so the
// field's own label is the single source of truth. Multi-field groups, or groups
// whose title differs from the field (e.g. "Additional Settings" -> "Endpoint URL"),
// keep their header.
function isRedundantGroupHeader(settingsData) {
  const properties = settingsData?.schema?.properties;
  if (!properties) {
    return false;
  }
  const keys = Object.keys(properties);
  return keys.length === 1 && keys[0] === settingsData.name;
}

function onDataChange(event, index, settingsData) {
  settingsData.data = event.data;
  additionalSettingsErrorMap.value.set(index, event.errors);
  dataList.value.splice(index, 1, settingsData);
}

function updateAuth(data) {
  authMap.value = cloneDeep(data);
}

function emptyPassword() {
  isPasswordFieldClicked.value = true;
  representPassword.value = "";
  authObject.value.basicAuth.password = "";
}

function emptyClientSecret() {
  isSecretFieldClicked.value = true;
  representClientSecret.value = "";
  authObject.value.oauth.clientSecret = "";
}

function hasError() {
  let error = false;
  additionalSettingsErrorMap.value.forEach((item) => {
    if (item.length) {
      error = true;
    }
  });
  return error;
}

onMounted(() => {
  splitRoute();
  watch(
    () => currentRoute.value.path,
    () => {
      splitRoute();
    }
  );
});

async function createOrUpdateConnection() {
  if (!hasPermission("CONNECTIONS.CONNECTION.SAVE")) {
    return;
  }
  if (!canSave.value) {
    showAlert(TYPE.WARNING, t("Connection.WarningMsg"));
    return;
  }
  responseLoading.value = true;
  if (isPasswordFieldClicked.value) {
    authObject.value.basicAuth.password =
      representPassword.value !== "*****" ? representPassword.value : "";
  } else {
    authObject.value.basicAuth.password = holdPassword.value;
  }
  if (isSecretFieldClicked.value) {
    authObject.value.oauth.clientSecret =
      representClientSecret.value !== "*****"
        ? representClientSecret.value
        : "";
  } else {
    authObject.value.oauth.clientSecret = holdClientSecret.value;
  }
  connection.value.authentication = authObject.value;
  connection.value.additionalSettings = additionalSettings.value;
  connection.value.authParams = JSON.stringify(convertToAuth(authMap.value));
  // Turning off certificate validation is confirmed explicitly rather than silently saved.
  if (!connection.value.sslValidation) {
    const confirmed = await showConfirm(
      "warning",
      t("Connection.SSLDisabled"),
      t("Connection.SSLDisabledMessage")
    );
    if (!confirmed) {
      responseLoading.value = false;
      return;
    }
  }
  await saveConnection(connection.value).then(async (response) => {
    if (response) {
      if (id.value) {
        showAlert(TYPE.SUCCESS, t("Connection.ConnectorUpdated"));
      } else {
        id.value = response.id;
        connection.value = response;
        showAlert(TYPE.SUCCESS, t("Connection.ConnectionCreated"));
      }
      await refreshDynamicSpecStatus(response.id, true);
      router.push(`/connections/edit/${response.id}`);
      checkOauth();
    }
  });
  responseLoading.value = false;
}

async function checkOauth() {
  if (
    authObject.value.authenticationType.toLowerCase() === "oauth" &&
    id.value
  ) {
    const response = await getOAuthUrl(id.value);
    if (response) {
      oauthResult.value = response;
      if (oauthResult.value.authorizeUrl) {
        openUrl();
      }
    }
  }
}
function openUrl() {
  if (oauthResult.value.authorizeUrl) {
    const width = 450;
    const height = 510;

    const openWindow = window.open(
      oauthResult.value.authorizeUrl,
      "",
      `
      width=${width},
      height=${height},
      `
    );
    const timer = setInterval(() => {
      if (openWindow.closed) {
        getAuthUrl();
        clearInterval(timer);
      }
    }, 1000);
    clicked.value = true;
  }
}

async function verifyLogin() {
  if (id.value) {
    verifyOauth(id.value).then((resp) => {
      if (resp) {
        if (resp.state === "CONNECTED") {
          verified.value = true;
          oauthResult.value.state = resp.state;
        }
      }
    });
  }
}

async function disconnectFromOAuth() {
  if (oauthResult.value.state === "CONNECTED") {
    const response = await disconnectOAuth(id.value);
    if (response) {
      verified.value = false;
      oauthResult.value.state = "DISCONNECTED";
      if (!connection.value.authentication.oauth) {
        await getAuthUrl();
      }
      if (connection.value.authentication.oauth.accessToken) {
        connection.value.authentication.oauth.accessToken = undefined;
      }
      if (connection.value.authentication.oauth.refreshToken) {
        connection.value.authentication.oauth.refreshToken = undefined;
      }
      if (connection.value.authentication.oauth.tokenExpiry) {
        connection.value.authentication.oauth.tokenExpiry = undefined;
      }
    }
  }
}

watch(
  () => selectedConnectorSpecId.value,
  async () => {
    specLoading.value = true;
    if (selectedConnectorSpecId.value) {
      await onSpecChange();
      if (
        selectedSpec.value &&
        !selectedSpec.value.supportedAuthTypes?.includes(
          connection.value.authentication.authenticationType
        )
      ) {
        connection.value.authentication.authenticationType = undefined;
      }

      connection.value.connector = connectorList.value.find(
        (item) => item.connectorSpecId === selectedConnectorSpecId.value
      );
      authItems.value = await getConnectorAuthSchemas(
        selectedConnectorSpecId.value
      );
      // When the only supported auth type is NONE the dropdown is hidden, so default the type to
      // that sole value here to keep a valid auth type on the saved connection.
      if (!authItems.value && onlyNoneAuth.value) {
        [connection.value.authentication.authenticationType] =
          selectedSpec.value.supportedAuthTypes;
      }
      await getAuthUrl();
      if (connection.value.authParams) {
        authMap.value = convertDataToAuthList(
          JSON.parse(connection.value.authParams),
          authItems.value
        );
      }
    } else {
      selectedSpec.value = undefined;
    }
    specLoading.value = false;
  }
);

watch(
  () => representPassword.value,
  () => {
    if (
      representPassword.value === "*****" ||
      representPassword.value !== holdPassword.value.substring(0, 10)
    ) {
      isPasswordFieldClicked.value = true;
      authObject.value.basicAuth.password = "";
    } else {
      isPasswordFieldClicked.value = false;
    }
  }
);
watch(
  () => representClientSecret.value,
  () => {
    if (
      representClientSecret.value === "*****" ||
      representClientSecret.value !== holdClientSecret.value.substring(0, 10)
    ) {
      isSecretFieldClicked.value = true;
      authObject.value.oauth.clientSecret = "";
    } else {
      isSecretFieldClicked.value = false;
    }
  }
);

async function onSpecChange() {
  if (selectedConnectorSpecId.value) {
    dataList.value = [];
    await getConnectorSpecById(selectedConnectorSpecId.value).then((resp) => {
      if (resp) {
        selectedSpec.value = resp.spec;
        if (selectedSpec.value.connectionSettingsSchemas) {
          if (connection.value.additionalSettings) {
            convertDataToList(connection.value.additionalSettings);
          } else {
            convertToEmptyDataList(
              selectedSpec.value.connectionSettingsSchemas
            );
          }
        } else {
          dataList.value = [];
          connection.value.additionalSettings = {};
        }
      }
    });
  }
}

function convertToEmptyDataList(list) {
  list.forEach((schema) => {
    dataList.value.push({
      schema,
      name: schema.title,
      description: schema.description,
      data: {},
    });
  });
}

function convertDataToList(data) {
  if (data) {
    if (Object.keys(data).length !== 0) {
      Object.values(data).forEach((value: any) => {
        const objSchema = selectedSpec.value.connectionSettingsSchemas.find(
          (item) => item.title === value.name
        );
        if (objSchema) {
          dataList.value.push({
            schema: objSchema,
            name: value.name,
            description: value.description,
            data: convertObject(value.connectionSettingDefinitions),
          });
        }
      });
    } else {
      convertToEmptyDataList(selectedSpec.value.connectionSettingsSchemas);
    }
  }
}

watch(
  () => connection.value.authentication.authenticationType,
  async () => {
    authObject.value.authenticationType =
      connection.value.authentication.authenticationType;
    if (authObject.value.authenticationType === "OAUTH" && id.value) {
      const resp = await getOAuthUrl(id.value);
      if (resp) {
        oauthResult.value = resp;
        if (oauthResult.value.state === "CONNECTED") {
          verified.value = true;
        }
      }
      await verifyLogin();
    }
  }
);

async function getAuthUrl() {
  if (id.value) {
    const resp = await getOAuthUrl(id.value);
    if (resp) {
      oauthResult.value = resp;
      if (oauthResult.value.state === "CONNECTED") {
        verified.value = true;
      }
    }
  }
}

function convertDataToAuthList(data, list) {
  const dataMap = new Map();
  if (data && list) {
    if (Object.keys(data).length !== 0) {
      Object.entries(data).forEach(([key, value]: any[]) => {
        const objSchema = list.find((item) => item.name === key);
        if (objSchema !== undefined) {
          dataMap.set(key, {
            name: objSchema.name,
            schema: objSchema.uiSchema,
            // Carried through so convertToAuth uses the type the backend reports for the
            // scheme; without it a re-opened connection falls back to the name mapping and
            // re-persists a mixed-case type ("Oauth", "Basic", "Api_key").
            authenticationType: objSchema.authenticationType,
            requiresBrowserAuthentication:
              objSchema.requiresBrowserAuthentication
                ? objSchema.requiresBrowserAuthentication
                : false,
            flows: objSchema.flows,
            data: objSchema.flows ? {} : convertObject(value),
            flowData: objSchema.flows
              ? convertDataToAuthList(value, objSchema.flows)
              : new Map(),
          });
        }
      });
    }
  }
  return dataMap;
}

function splitRoute() {
  const getCurrentLanguage = currentRoute.value.path.split("/");
  if (getCurrentLanguage[1] === "en") {
    selectedLanguage.value = "english";
  } else {
    selectedLanguage.value = "turkish";
  }
}

onBeforeMount(async () => {
  pageLoading.value = true;
  await getOrganizationsConnectorList().then((connectorListDB) => {
    // Connection-optional connectors are used without a Connection, so they are not offered here.
    connectorList.value = (connectorListDB || []).filter(
      (c: any) => !c.connectionOptional
    );
  });

  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getConnection(id.value).then((response) => {
      if (response) {
        connection.value = response;
        selectedConnectorSpecId.value = response.connector.connectorSpecId;
        authObject.value.authenticationType = response.authenticationType;
        if (response.authentication.authenticationType === "BASIC") {
          authObject.value.basicAuth = response.authentication.basicAuth;
          holdPassword.value = authObject.value.basicAuth.password;
          representPassword.value = "*****";
        } else if (response.authentication.authenticationType === "TOKEN") {
          authObject.value.tokenAuth = response.authentication.tokenAuth;
        } else if (response.authentication.authenticationType === "OAUTH") {
          authObject.value.oauth = response.authentication.oauth;
          holdClientSecret.value = authObject.value.oauth.clientSecret;
          representClientSecret.value = "*****";
        } else if (response.authentication.authenticationType === "FORM") {
          authObject.value.formAuth = response.authentication.formAuth;
        } else if (response.authentication.authenticationType === "API_KEY") {
          authObject.value.apiKeyAuth = response.authentication.apiKeyAuth;
        }
      }
      changeListItemOfBreadcrumb({
        labelKey: "Common.Edit",
        route: "",
        disabled: true,
        isTranslated: false,
        uniqueLabel: connection.value.name,
      });
    });
    // Surface a persistent warning if the latest revision's spec generation failed.
    await refreshDynamicSpecStatus(id.value);
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Common.Connection")), 1),
          (selectedConnectorSpecId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "logo-step-header",
                    src: `${_unref(ASSETS_BASE_URL)}/${selectedConnectorSpecId.value}${_unref(getResolution)(
                true
              )}.png`,
                    alt: "logo"
                  }, null, 8, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (dynamicSpecFailed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_font_awesome_icon, {
                  class: "dynamic-spec-warning-icon",
                  icon: "info-circle"
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Connection.DynamicSpecFailedTitle")), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("Connection.DynamicSpecFailedMessage", {
                reason:
                  dynamicSpecStatus.value?.lastError || _unref(t)("Common.UnknownError"),
              })), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", null, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("Connection.ConnectionName")), 1),
                  _hoisted_13
                ])
              ]),
              _createVNode(_unref(ElInput), {
                modelValue: connection.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((connection.value.name) = $event)),
                id: "connection-name",
                size: "small",
                placeholder: _unref(t)('Connection.ConnectionName')
              }, null, 8, ["modelValue", "placeholder"]),
              (isNameNearLimit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", { limit: charLimit.value })), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Connector")), 1),
                  _hoisted_18
                ]),
                _createElementVNode("button", {
                  id: "show-modal",
                  class: "info-support",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = true))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "info-circle" })
                ])
              ]),
              _createVNode(_unref(ElSelect), {
                modelValue: selectedConnectorSpecId.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedConnectorSpecId).value = $event)),
                id: "connection-connector-select",
                filterable: "",
                size: "small",
                placeholder: _unref(t)('Common.SelectConnector')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectorList.value.sort((a, b) =>
                  a.name.localeCompare(b.name)
                ), (connector) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      id: connector.connectorSpecId,
                      label: connector.name,
                      value: connector.connectorSpecId,
                      key: connector.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_19, [
                          _createElementVNode("img", {
                            class: "logo-30",
                            src: `${_unref(ASSETS_BASE_URL)}/${
                      connector.connectorSpecId
                    }${_unref(getResolution)(false)}.png`,
                            alt: "logo"
                          }, null, 8, _hoisted_20),
                          _createTextVNode("  " + _toDisplayString(connector.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            (!specLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (settingsData, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "margin-top-10 d-flex flex-column",
                      key: settingsData.name
                    }, [
                      (!isRedundantGroupHeader(settingsData))
                        ? (_openBlock(), _createElementBlock("label", _hoisted_22, [
                            _createElementVNode("strong", null, _toDisplayString(settingsData.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(), _createBlock(_unref(JsonForms), {
                        data: settingsData.data,
                        key: settingsData.schema,
                        schema: settingsData.schema,
                        ajv: _unref(ajv),
                        renderers: _unref(renderers),
                        onChange: ($event: any) => (onDataChange($event, index, settingsData))
                      }, null, 8, ["data", "schema", "ajv", "renderers", "onChange"]))
                    ]))
                  }), 128)),
                  (authItems.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("strong", null, [
                          _createTextVNode(_toDisplayString(_unref(t)("Connection.Authentication")), 1),
                          _hoisted_24
                        ]),
                        _createVNode(_unref(AuthenticationForm), {
                          "auth-list": authItems.value,
                          data: authMap.value,
                          multiple: false,
                          "auth-result": oauthResult.value,
                          onUpdate: updateAuth,
                          onErrors: _cache[3] || (_cache[3] = ($event: any) => (authErrors.value = $event)),
                          onVerifyLogin: verifyLogin,
                          verified: verified.value,
                          clicked: clicked.value,
                          "connection-id": id.value,
                          onDisconnectFromOauth: disconnectFromOAuth,
                          onOpenUrl: openUrl
                        }, null, 8, ["auth-list", "data", "auth-result", "verified", "clicked", "connection-id"])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedSpec.value && !authItems.value && !onlyNoneAuth.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("strong", null, [
                          _createTextVNode(_toDisplayString(_unref(t)("Connection.Authentication")), 1),
                          _hoisted_26
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_unref(ElSelect), {
                            modelValue: connection.value.authentication.authenticationType,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((connection.value.authentication.authenticationType) = $event)),
                            filterable: "",
                            id: "connection-authentication-type",
                            size: "small",
                            placeholder: _unref(t)('Common.SelectAuth')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSpec.value.supportedAuthTypes, (item, index) => {
                                return (_openBlock(), _createBlock(_unref(ElOption), {
                                  id: 'connection-authentication-option-' + index,
                                  label: item,
                                  value: item,
                                  key: item
                                }, null, 8, ["id", "label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"]),
                          (oauthResult.value.state)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (
                      connection.value.authentication.authenticationType === 'OAUTH'
                    )
                                  ? (_openBlock(), _createElementBlock("label", {
                                      key: 0,
                                      class: _normalizeClass(
                      oauthResult.value.state === 'DISCONNECTED'
                        ? 'color-red'
                        : 'color-green'
                    )
                                    }, _toDisplayString(oauthResult.value.state), 3))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                connection.value.authentication.authenticationType === 'BASIC' &&
                !authItems.value
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("User.UserName")), 1),
                              _hoisted_30
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.basicAuth.username,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((authObject.value.basicAuth.username) = $event)),
                            id: "connection-basic-username",
                            size: "small",
                            placeholder: _unref(t)('User.UserName'),
                            style: {"height":"5px"}
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("label", _hoisted_32, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Password")), 1),
                              _hoisted_33
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: representPassword.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((representPassword).value = $event)),
                            id: "connection-basic-password",
                            type: "password",
                            size: "small",
                            "show-password": "",
                            placeholder: _unref(t)('Common.Password'),
                            onClick: emptyPassword
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Endpoint")), 1),
                              _hoisted_35
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.basicAuth.endPoint,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((authObject.value.basicAuth.endPoint) = $event)),
                            id: "connection-basic-endpoint",
                            size: "small",
                            placeholder: _unref(t)('Common.Endpoint')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                connection.value.authentication.authenticationType === 'FORM' &&
                !authItems.value
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Form")), 1),
                              _hoisted_38
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.formAuth.form,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((authObject.value.formAuth.form) = $event)),
                            id: "connection-formAuth-form",
                            size: "small",
                            placeholder: _unref(t)('Common.Form')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Endpoint")), 1),
                              _hoisted_40
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.formAuth.endPoint,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((authObject.value.formAuth.endPoint) = $event)),
                            id: "connection-formAuth-endpoint",
                            size: "small",
                            placeholder: _unref(t)('Common.Endpoint')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                connection.value.authentication.authenticationType === 'TOKEN' &&
                !authItems.value
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Connection.AuthToken")), 1),
                              _hoisted_43
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.tokenAuth.authToken,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((authObject.value.tokenAuth.authToken) = $event)),
                            id: "connection-tokenAuth-token",
                            size: "small",
                            placeholder: _unref(t)('Connection.AuthToken')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Endpoint")), 1),
                              _hoisted_45
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.tokenAuth.endPoint,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((authObject.value.tokenAuth.endPoint) = $event)),
                            id: "connection-tokenAuth-endpoint",
                            size: "small",
                            placeholder: _unref(t)('Common.Endpoint')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                connection.value.authentication.authenticationType === 'API_KEY' &&
                !authItems.value
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Connection.ApiKey")), 1),
                              _hoisted_48
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.apiKeyAuth.apiKey,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((authObject.value.apiKeyAuth.apiKey) = $event)),
                            id: "connection-apiKeyAuth-apiKey",
                            placeholder: _unref(t)('Connection.ApiKey')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("label", null, [
                            _createElementVNode("strong", null, [
                              _createTextVNode(_toDisplayString(_unref(t)("Connection.ApiKeyName")), 1),
                              _hoisted_50
                            ])
                          ]),
                          _createVNode(_unref(ElInput), {
                            modelValue: authObject.value.apiKeyAuth.nameInHeader,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((authObject.value.apiKeyAuth.nameInHeader) = $event)),
                            id: "connection-apiKeyAuth-nameInHeader",
                            placeholder: _unref(t)('Connection.ApiKeyName')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                connection.value.authentication.authenticationType === 'OAUTH' &&
                !authItems.value
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("label", null, [
                              _createElementVNode("strong", null, [
                                _createTextVNode(_toDisplayString(_unref(t)("Common.ClientId")), 1),
                                _hoisted_54
                              ])
                            ]),
                            _createVNode(_unref(ElInput), {
                              modelValue: authObject.value.oauth.clientId,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((authObject.value.oauth.clientId) = $event)),
                              id: "connection-authObject-client-id",
                              size: "small",
                              placeholder: _unref(t)('Common.ClientId')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("label", null, [
                              _createElementVNode("strong", null, [
                                _createTextVNode(_toDisplayString(_unref(t)("Common.ClientSecret")), 1),
                                _hoisted_56
                              ])
                            ]),
                            _createVNode(_unref(ElInput), {
                              modelValue: representClientSecret.value,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((representClientSecret).value = $event)),
                              id: "connection-authObject-client-secret",
                              type: "password",
                              size: "small",
                              onClick: emptyClientSecret,
                              placeholder: _unref(t)('Common.ClientSecret')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("label", null, [
                              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CallbackUrl")), 1)
                            ]),
                            _createVNode(_unref(ElInput), {
                              modelValue: authObject.value.oauth.callbackUrl,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((authObject.value.oauth.callbackUrl) = $event)),
                              disabled: true,
                              id: "connection-authObject-callback-url",
                              size: "small",
                              placeholder: _unref(t)('Common.CallbackUrl')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          (id.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                (oauthResult.value.state === 'CONNECTED')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "google-button",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (disconnectFromOAuth()))
                                    }, _toDisplayString(_unref(t)("Common.SignOut")), 1))
                                  : _createCommentVNode("", true),
                                (clicked.value && id.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "google-button margin-top-10",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (verifyLogin()))
                                    }, _toDisplayString(!verified.value ? _unref(t)("Common.Verify") : _unref(t)("Common.Verified")), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.SSLValidation")), 1)
                    ]),
                    _createVNode(_unref(ElSwitch), {
                      "active-color": "#5022a6",
                      modelValue: connection.value.sslValidation,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((connection.value.sslValidation) = $event)),
                      onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.FollowRedirects")), 1)
                    ]),
                    _createVNode(_unref(ElSwitch), {
                      "active-color": "#5022a6",
                      modelValue: connection.value.followRedirects,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((connection.value.followRedirects) = $event)),
                      onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _withDirectives(_createElementVNode("div", _hoisted_62, [
                    _createElementVNode("img", {
                      src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                      alt: "Loading...",
                      class: "loader-logo-40"
                    }, null, 8, _hoisted_63)
                  ], 512), [
                    [_vShow, specLoading.value]
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_unref(ElButton), {
              class: "btn-oneTeg3",
              id: "connection-back",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_unref(router).push('/connections')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
              ]),
              _: 1
            }),
            (_unref(hasPermission)('CONNECTIONS.CONNECTION.SAVE'))
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 0,
                  class: "btn-oneTeg2",
                  id: "connection-submit",
                  type: "primary",
                  onClick: createOrUpdateConnection,
                  disabled: isNameNearLimit.value || !canSave.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !pageLoading.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_66, [
        _createElementVNode("img", {
          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
          alt: "Loading...",
          class: "loader-logo-40"
        }, null, 8, _hoisted_67)
      ], 512), [
        [_vShow, responseLoading.value || pageLoading.value]
      ])
    ]),
    (selectedLanguage.value === 'english')
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          show: showModal.value
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("a", {
                class: "",
                href: helpUrl.value,
                target: "_blank"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "info-circle" }),
                _createTextVNode(" Help")
              ], 8, _hoisted_69)
            ])
          ]),
          body: _withCtx(() => [
            _createElementVNode("object", {
              id: "iframe",
              data: helpUrl.value,
              class: "embedObject",
              width: "480",
              height: "320"
            }, [
              _createElementVNode("embed", {
                src: helpUrl.value,
                width: "480",
                height: "320"
              }, null, 8, _hoisted_71),
              _createTextVNode(" Error: Embedded data could not be displayed. ")
            ], 8, _hoisted_70)
          ]),
          footer: _withCtx(() => [
            _createVNode(_unref(ElButton), {
              class: "btn-oneTeg2",
              style: {"margin":"10px"},
              type: "primary",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (showModal.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Got it")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})